import './styles/_image-grid.scss';
import Swiper from 'swiper-latest/bundle';
import { ProductCard } from "../common/product-card-class";
import { initializeProductOption } from '../collections-page/product-item';
import {
  isScriptFullyLoaded,
  markScriptFullyLoaded,
  onDocumentReady,
} from '../utils/dom';

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.01,
};

const state = {
  variables: {
    title: 'image-grid',
  },
  elements: {},
};

let userComeAcrossWithSection = false;

const cacheState = () => {
  state.elements = {
    itemsSections: document.querySelectorAll('.image-grid-item'),
    productCards: document.querySelectorAll('.product-item.product-grid-item'),
  };
  const sections = Array.from(document.querySelectorAll('.image-grid[data-section-id]'));
  state.components = sections.reduce((acc, curr) => {
    const currentComponent = {
      swiperEl: curr.querySelector('.swiper.image-grid-item'),
      totalSlides: Array.from(curr.querySelectorAll('.image-grid-item .swiper-slide')).length,
      banners: Array.from(curr.querySelectorAll('.image-grid-item .swiper-slide')),
    };
    return [...acc, currentComponent];
  }, []);
};

function initVideo() {
  state.components?.forEach((component) => {
    const { banners } = component;

    banners?.forEach((banner) => {
      const videoEl = banner.querySelector('video');
      if (!videoEl) return;

      let wasPlaying = true;
      let wasMuted = true;
      const playPauseBtn = banner.querySelector('[data-video-type="video"]');
      const muteUnmuteBtn = banner.querySelector('[data-audio-type="audio"]');

      playPauseBtn.addEventListener('click', () => {
        if (playPauseBtn.dataset.state === 'playing') {
          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
        } else {
          videoEl.play();
          playPauseBtn.dataset.state = 'playing';
        }
      });

      muteUnmuteBtn.addEventListener('click', () => {
        if (muteUnmuteBtn.dataset.state === 'muted') {
          videoEl.muted = false;
          muteUnmuteBtn.dataset.state = 'unmuted';
        } else {
          videoEl.muted = true;
          muteUnmuteBtn.dataset.state = 'muted';
        }
      });

      document.addEventListener('swiper:slide:changed', () => {
        if (playPauseBtn.dataset.state === 'playing') {
          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
        } else if (
          videoEl.closest('.slider__item').classList.contains('active')
        ) {
          videoEl.play();
          playPauseBtn.dataset.state = 'playing';
        }
      });

      const observer = new IntersectionObserver((e) => {
        if (!e[0].isIntersecting) {
          if (userComeAcrossWithSection) {
            wasPlaying = !videoEl.paused;
          }
          wasMuted = videoEl.muted;

          videoEl.pause();
          playPauseBtn.dataset.state = 'paused';
          return;
        }

        videoEl.muted = wasMuted;
        userComeAcrossWithSection = true;
        if (!wasPlaying) return;

        videoEl.play();
        playPauseBtn.dataset.state = 'playing';
      }, options);
      observer.observe(videoEl);
    });
  });
}

const initializeSwiper = () => {
  state.elements.itemsSections?.forEach((swiperContainer) => {
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      navigation: {
        nextEl: swiperContainer.querySelector('.swiper-button-next'),
        prevEl: swiperContainer.querySelector('.swiper-button-prev'),
      },  
    })
  })
};

function initProductCards() {
    state.elements.productCards.forEach((card) => {
        const productCard = new ProductCard(card)
    })
}

function reinitializeSectionedSwiper() {
  state.elements.itemsSections.forEach((swiperContainer) => {
    if(swiperContainer.classList.contains("image-grid-item--sectioned")) {
      swiperContainer.swiper.destroy(false,true);
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
          nextEl: swiperContainer.querySelector('.swiper-button-next'),
          prevEl: swiperContainer.querySelector('.swiper-button-prev'),
        },  
      })
    }
  })
}
const init = () => {
  if (isScriptFullyLoaded(state.variables.title)) return;
  markScriptFullyLoaded(state.variables.title);
  cacheState();
  initializeSwiper();
  reinitializeSectionedSwiper()
  initVideo();
  initProductCards();
  initializeProductOption();
};

onDocumentReady(init);